import { useContext } from 'react';
import { ButtonToolbar } from 'reactstrap';
import CreateSectionButton from './buttons/CreateSectionButton';
import NewLayerButton from './buttons/NewLayerButton';
import { mapModes, measurementModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import RulerIcon from '../icons/RulerIcon';
import ButtonWithShortcut from '../basics/ButtonWithShortcut';
import { SHORTCUTS } from '../../constants/shortcuts';
import { captureEvent } from '../../utils/analytics';
import MapCenterSearch from './buttons/MapCenterSearch';

const ViewToolbar = () => {
  const {
    mapState: { setMapMode },
  } = useContext(MapContext);
  return (
    <ButtonToolbar>
      <MapCenterSearch />
      <CreateSectionButton />
      <NewLayerButton className="fs-new-layer-button ml-2" size="sm" outline />
      <ButtonWithShortcut
        onClick={() => {
          setMapMode(mapModes.MEASUREMENT, null, {
            measurementMode: measurementModes.DISTANCE,
          });
          captureEvent('measurement-mode-entered');
        }}
        shortcut={SHORTCUTS.START_MEASUREMENT.key}
        className="ml-2"
        size="sm"
        outline
      >
        <RulerIcon />
      </ButtonWithShortcut>
    </ButtonToolbar>
  );
};

export default ViewToolbar;
